import { Close } from '@mui/icons-material';
import {
  Box,
  capitalize,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import moment from 'moment';
import GetSocialMediaIcon from 'src/components/GetSocialMediaIcon';
import { IObject } from 'src/models/objectManagement';

import { addSymbolObject } from 'src/utils/addSymbolObject';
import { getSocialMediaColor } from 'src/utils/getSocialMediaColor';
import { getStatusColor } from 'src/utils/getStatusColor';

export default function ObjectDetailPopup({
  open,
  handleClose,
  object
}: {
  open: boolean;
  handleClose: () => void;
  object: IObject;
}) {
  const theme = useTheme();

  return (
    <>
      <Dialog onClose={handleClose} open={open} fullWidth maxWidth={'sm'}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <Close />
        </IconButton>
        <DialogTitle
          sx={{
            m: theme.spacing(3, 3, 0),
            p: theme.spacing(2, 3, 0, 3)
          }}
        >
          <Typography variant="h3">Object Detail</Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            m: { xs: 0, sm: theme.spacing(1, 3) }
          }}
        >
          <Stack spacing={2}>
            <Box
              sx={{
                backgroundColor: theme.colors.primary.light,
                padding: theme.spacing(1),
                borderRadius: theme.spacing(1),
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 1
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '100%',
                  backgroundColor: getSocialMediaColor(object.socialMedia),
                  padding: theme.spacing(1)
                }}
              >
                <GetSocialMediaIcon
                  fontSize="medium"
                  socialMedia={object.socialMedia}
                  sx={{ color: 'white' }}
                />
              </Box>
              <Typography variant="h5">
                {addSymbolObject(object).objectName}
              </Typography>
            </Box>
            <Stack spacing={2}>
              <Typography variant="h4">Object Information</Typography>
              <Grid container gap={2}>
                <Grid xs={5}>
                  <Typography variant="h6">Processing Status</Typography>
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6" fontWeight={700} color="black">
                    <Chip
                      size="small"
                      label={capitalize(object.status)}
                      sx={{
                        fontWeight: 700,
                        backgroundColor: `${getStatusColor(object.status)}30`,
                        color: getStatusColor(object.status)
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6">Object Type</Typography>
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6" fontWeight={700} color="black">
                    {object.streamType === 'post_link'
                      ? 'Post Link'
                      : object.streamType === 'keyword' && object.isHashtag
                      ? 'Hashtag'
                      : capitalize(object.streamType)}
                  </Typography>
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6">Source</Typography>
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6" fontWeight={700} color="black">
                    {object.socialMedia === 'twitter'
                      ? 'X'
                      : capitalize(object.socialMedia)}
                  </Typography>
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6">Data Added</Typography>
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6" fontWeight={700} color="black">
                    {moment(object.createdAt).format('ddd, MMM DD YYYY HH:mm')}
                  </Typography>
                </Grid>
                {/* <Grid xs={5}>
                  <Typography variant="h6">Last Data Update</Typography>
                </Grid>
                <Grid xs={5}>
                  {object.lastDataUpdated ? (
                    <>
                      <Typography variant="h6" fontWeight={700} color="black">
                        {moment(object.lastDataUpdated).format(
                          'ddd, MMM DD YYYY HH:mm'
                        )}
                      </Typography>
                    </>
                  ) : (
                    <Chip
                      size="small"
                      label="On Progress"
                      sx={{
                        fontWeight: 400,
                        backgroundColor: themeColors.blue,
                        color: 'white'
                      }}
                    />
                  )}
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6">First Data Timestamp</Typography>
                </Grid>
                <Grid xs={5}>
                  <Typography variant="h6" fontWeight={700} color="black">
                    {moment(object.createdAt).format('ddd, MMM DD YYYY HH:mm')}
                  </Typography>
                </Grid> */}
              </Grid>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
